// extracted by mini-css-extract-plugin
export default {"card":"Card_card__dJZ2Z","header":"Card_header__hnj4z","title":"Card_title__jgCzb","subtitle":"Card_subtitle__lYk03","body":"Card_body__f6ROd","buttons":"Card_buttons__cNjkm"};